const MIN_HEIGHT = 48

function resize(el: HTMLTextAreaElement) {
  el.style.height = 'auto'
  el.style.height = `${Math.max(MIN_HEIGHT, el.scrollHeight)}px`
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('autosize', {
    mounted(el: HTMLTextAreaElement) {
      if (el.tagName !== 'TEXTAREA') return
      resize(el)
      const onInput = () => resize(el)
      el.addEventListener('input', onInput)
      ;(el as HTMLTextAreaElement & { _autosizeCleanup?: () => void })._autosizeCleanup = () =>
        el.removeEventListener('input', onInput)
    },
    updated(el: HTMLTextAreaElement) {
      if (el.tagName !== 'TEXTAREA') return
      resize(el)
    },
    beforeUnmount(el: HTMLTextAreaElement) {
      const elWithCleanup = el as HTMLTextAreaElement & { _autosizeCleanup?: () => void }
      elWithCleanup._autosizeCleanup?.()
    },
  })
})
